import React, { createContext, useContext, useEffect } from 'react';
import { useState } from 'react';
import _ from 'lodash';
import { getFromSessionStorage } from '../utils/utils';

const UserContext = createContext({});

const handleGetStorage = () => {
  return getFromSessionStorage('user', {});
};

const handleGetLogged = () => {
  const isLogged = !_.isEmpty(handleGetStorage());
  return isLogged;
};

const handleSaveStorage = user => {
  sessionStorage.setItem('user', JSON.stringify(user));
};

const handleRemoveStorage = () => {
  sessionStorage.setItem('user', '');
  sessionStorage.removeItem('user');
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(handleGetStorage());
  const [isLogged, setIsLogged] = useState(handleGetLogged());
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleUser = change => {
    handleSaveStorage(change);
    setUser(change);
  };

  const handleLogged = (boolean = true) => {
    setIsLogged(boolean);
  };

  const removeUser = () => {
    setUser(null);
    setIsLogged(false);
    handleRemoveStorage();
  };

  return (
    <UserContext.Provider
      value={{
        user: user ?? {},
        windowWidth: windowWidth,
        isLogged,
        handleUser: handleUser,
        removeUser: removeUser,
        handleLogged,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const { user, handleUser, removeUser, isLogged, handleLogged, windowWidth } =
    useContext(UserContext);
  return { user, handleUser, removeUser, isLogged, handleLogged, windowWidth };
};

export default UserContext;

